import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MenuHoursExpiredNotification from 'base/components/MenuHoursExpiredNotification';

import { goToOrderSettings } from 'cart/actions/orderSettings';
import { updateFulfillmentOptionsForCartLocation } from 'locations/actions/locationFulfillmentOptions';
class MenuHoursExpiredNotificationContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
  };

  handlePrimaryCta = async () => {
    const { dispatch } = this.props;
    await dispatch(updateFulfillmentOptionsForCartLocation());
    dispatch(goToOrderSettings());
  };

  render() {
    return (
      <MenuHoursExpiredNotification
        handlePrimaryCta={this.handlePrimaryCta}
        closeModal={this.props.closeModal}
      />
    );
  }
}

export default connect()(MenuHoursExpiredNotificationContainer);
